var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.48 3H7.52C4.07 3 2 5.06 2 8.52V16.47C2 19.94 4.07 22 7.52 22H15.47C18.93 22 20.99 19.94 20.99 16.48V8.52C21 5.06 18.93 3 15.48 3Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0195 2.98C19.2295 1.18 17.4795 1.14 15.6395 2.98L14.5095 4.1C14.4095 4.2 14.3795 4.34 14.4195 4.47C15.1195 6.92 17.0795 8.88 19.5295 9.58C19.5595 9.59 19.6095 9.59 19.6395 9.59C19.7395 9.59 19.8395 9.55 19.9095 9.48L21.0195 8.36C21.9295 7.45 22.3795 6.58 22.3795 5.69C22.3795 4.79 21.9295 3.9 21.0195 2.98Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8591 10.42C17.5891 10.29 17.3291 10.16 17.0891 10.01C16.8891 9.89 16.6891 9.76 16.4991 9.62C16.3391 9.52 16.1591 9.37 15.9791 9.22C15.9591 9.21 15.8991 9.16 15.8191 9.08C15.5091 8.83 15.1791 8.49 14.8691 8.12C14.8491 8.1 14.7891 8.04 14.7391 7.95C14.6391 7.84 14.4891 7.65 14.3591 7.44C14.2491 7.3 14.1191 7.1 13.9991 6.89C13.8491 6.64 13.7191 6.39 13.5991 6.13C13.4691 5.85 13.3691 5.59 13.2791 5.34L7.89912 10.72C7.54912 11.07 7.20912 11.73 7.13912 12.22L6.70912 15.2C6.61912 15.83 6.78912 16.42 7.17912 16.81C7.50912 17.14 7.95912 17.31 8.45912 17.31C8.56912 17.31 8.67912 17.3 8.78912 17.29L11.7591 16.87C12.2491 16.8 12.9091 16.47 13.2591 16.11L18.6391 10.73C18.3891 10.65 18.1391 10.54 17.8591 10.42Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.620aa33bdcef970c435063eb8bf0257a.svg";
export { ForwardRef as ReactComponent };